module.exports = __webpack_public_path__ + "00_hair.16609dfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/00_hair.png
// module id = bfEt
// module chunks = 0